import React, { useEffect, useState } from "react";
import { Form, Input, Typography } from "antd";
import Modal from "components/Modal/Modal";
import { FormInput, FormInputArea } from "components/FormItems/FlatFormItems";
import { Button } from "components/Buttons/Buttons";

const { TextArea } = Input;
const { Text } = Typography;

export default function FlagReasonModal({ visible, onCancel, onSave }) {
  const [form] = Form.useForm();

  const handleOk = () => {
    form
      .validateFields()
      .then((values) => {
        onSave(values.note); // Pass the note value to the onSave handler
      })
      .catch((info) => {
        console.log("Validate Failed:", info);
      });
  };

  useEffect(() => {
    if (visible === false) {
      form.resetFields();
    }
  }, [visible]);

  return (
    <Modal
      title="Add Flag Reason"
      visible={visible}
      onOk={handleOk}
      onCancel={onCancel}
      footer={[
        <Button key="back" rounded variant="outlined" onClick={onCancel}>
          Cancel
        </Button>,
        <Button rounded key="submit" onClick={handleOk}>
          Flag Profile
        </Button>,
      ]}
    >
      <Text>Reason for flagging a profile.</Text>
      <Form
        form={form}
        layout="vertical"
        name="profile_flag_form"
        initialValues={{
          modifier: "public",
        }}
        requiredMark={false}
      >
        <FormInputArea
          variant="underlined"
          rows={4}
          name="note"
          label="Note"
          placeholder="Provide the reason"
          formItemStyles={{ marginBottom: 0 }}
          required={true}
        />
      </Form>
    </Modal>
  );
}
